"use client";
import { j as d } from "./jsx-runtime-CJ-St4mQ.mjs";
import { g as f } from "./_commonjsHelpers-CXJ7dpIk.mjs";
import { useMemo as h, Children as v, isValidElement as C } from "react";
import { t as p } from "./tv.config-BuYIgndg.mjs";
import { a as x, C as g } from "./CardMedia-BrosqCVD.mjs";
import q from "./Paper.js";
var i, u;
function P() {
  if (u) return i;
  u = 1;
  function r(t) {
    return t && t.length ? t[0] : void 0;
  }
  return i = r, i;
}
var o, l;
function b() {
  return l || (l = 1, o = P()), o;
}
var j = b();
const E = /* @__PURE__ */ f(j);
var a, m;
function R() {
  if (m) return a;
  m = 1;
  function r(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return a = r, a;
}
var _ = R();
const F = /* @__PURE__ */ f(_), M = p({
  base: ["Card__Root shadow-md", "p-0", "rounded-xl"],
  variants: {
    outlined: {
      true: ["border", "border-gray-300", "shadow-none"]
    }
  }
}), w = (r) => {
  const { outlined: t, ...n } = r, s = (e) => C(e) && e.type === g, c = h(() => {
    const e = v.toArray(r.children);
    return {
      mediaPosition: s(E(e)) ? "top" : s(F(e)) ? "bottom" : "middle",
      contentPosition: "middle",
      actionPosition: "bottom",
      headerPosition: "top"
    };
  }, [r.children]);
  return /* @__PURE__ */ d.jsx(x.Provider, { value: c, children: /* @__PURE__ */ d.jsx(
    q,
    {
      ref: r.ref,
      variant: t ? "outlined" : "elevation",
      className: M({ outlined: t }),
      ...n
    }
  ) });
};
w.displayName = "Card";
export {
  w as default
};
